import React, { ReactElement, useState } from 'react';
import { HeadTag } from 'shared/components';
import { Box, Stack } from '@mui/material';
import {
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import { useNavigate, useParams } from 'react-router-dom';
import AchievementForm from 'modules/training/training-programs/forms/AchievementForm';
import { TrainingPorgramsService } from 'services/TrainingProgramService';
import { Toast, Utils } from 'shared/helpers';
import { Formik } from 'formik';
import TrainingContent from '../forms/TraningContent';
import LinkOutsideTraining from '../forms/LinkOutsideTraining';
import RiskManagementForm from '../forms/RiskManagementForm';
import { TrainingProgramsExternalScheme } from 'validators/TrainingProgramsScheme';
import PageHeader from 'shared/components/PageHeader';

const ExternalTrainingPrograms = ({
  purpose = null,
  defaultData = null,
}: any): ReactElement => {
  const navigate = useNavigate();
  const { trainingId } = useParams();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmitValues = (submittedValues: any): void => {
    const {
      title,
      format,
      ai_rmf_domains,
      prerequisites,
      learning_objectives,
      status,
      external_urls,
      external_provider,
      duration_minutes,
      content,
    } = submittedValues;

    const target_roles = submittedValues.role;
    const program_type = 'external';

    const payload = {
      program_data: {
        title,
        external_urls,
        external_provider,
        duration_minutes,
        target_roles,
        ai_rmf_domains,
        prerequisites,
        learning_objectives,
        program_type,
        format,
        status,
        content,
      },
    };

    if (purpose === 'editing') {
      TrainingPorgramsService.updateTrainingProgram(payload, trainingId)
        .then(() => {
          Toast.showSuccessMessage('Training program updated successfully.');
          navigate('/training-programs');
        })
        .catch((error) => {
          Utils.handleErrorResponse(error);
        });
      return;
    }

    TrainingPorgramsService.createTrainingProgram(payload)
      .then(() => {
        Toast.showSuccessMessage('Training program created successfully.');
        navigate('/training-programs');
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      });
  };

  return (
    <>
      <PageHeader
        title="Add External Training Material"
        description="Add details for the external training course."
      />
      <Box className="training form-training-programs">
        <HeadTag
          title={
            purpose === 'editing'
              ? 'Edit Training Programs'
              : 'Create Training Programs'
          }
        />

        <Formik
          initialValues={
            purpose === 'editing'
              ? {
                  // Basic
                  title: defaultData?.title,
                  external_urls: defaultData?.external_urls,
                  external_provider: defaultData?.external_provider,
                  // Content
                  duration_minutes: defaultData?.duration_minutes,
                  prerequisites: defaultData?.prerequisites,
                  learning_objectives: defaultData?.learning_objectives,
                  // Achievement
                  target_roles: defaultData?.target_roles,
                  ai_rmf_domains: defaultData?.ai_rmf_domains,
                  program_type: defaultData?.program_type,
                  format: defaultData?.format,
                  status: defaultData?.status,
                  role: defaultData?.target_roles || [],
                  customtype: defaultData?.customtype,
                }
              : {
                  // Basic
                  title: '',
                  external_urls: [
                    {
                      url: '',
                      name: '',
                    },
                  ],
                  external_provider: '',
                  // Content
                  duration_minutes: '',
                  prerequisites: [],
                  learning_objectives: [],
                  // Achievement
                  target_roles: '',
                  ai_rmf_domains: '',
                  program_type: '',
                  format: '',
                  status: '',
                  role: [],
                  customtype: '',
                }
          }
          onSubmit={(values) => handleSubmitValues(values)}
          validationSchema={TrainingProgramsExternalScheme}
        >
          {({ values, handleSubmit, errors }: any) => {
            console.log(errors);
            return (
              <>
                <Box className="add-training-wrapper">
                  <LinkOutsideTraining test={undefined} />
                  <RiskManagementForm test={undefined} />
                  <TrainingContent
                    test={undefined}
                    purpose="external"
                    errorMessageContent={isSubmitted && errors?.content}
                    errorMessagePrerequisites={
                      isSubmitted &&
                      values?.prerequisites.length < 1 &&
                      errors?.prerequisites
                    }
                    errorMessageObjectives={
                      isSubmitted &&
                      values?.learning_objectives.length < 1 &&
                      errors?.learning_objectives
                    }
                  />
                  <AchievementForm test={undefined} />
                </Box>
                <Stack
                  direction="row-reverse"
                  className="button-training-programs"
                >
                  <AppPrimaryButton
                    title={
                      purpose === 'editing'
                        ? 'Update Training'
                        : 'Save Training'
                    }
                    onClick={() => {
                      setIsSubmitted(true);
                      handleSubmit();
                    }}
                  />
                  <AppPrimaryButtonOutlined
                    title="Cancel"
                    onClick={() => navigate('/training-programs/training')}
                  />
                </Stack>
              </>
            );
          }}
        </Formik>
      </Box>
    </>
  );
};

export default ExternalTrainingPrograms;
